export default __webpack_public_path__ + "static/wedding_1-619fcd8bfc69f9679165b6cf4bf48e23.png";